import type { ModalState, ViewMode } from "@typings/pages";
import { createContext } from "react";

export type BreadcrumbItem = {
  label: string;
  path?: string;
};

type PageContextType = {
  activePage: string;
  setActivePage: (page: string) => void;

  breadcrumb: BreadcrumbItem[];
  setBreadcrumb: (path: BreadcrumbItem[]) => void;

  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;

  areaMap: GeoJSON.FeatureCollection | null;
  setAreaMap: (areaMap: GeoJSON.FeatureCollection | null) => void;

  openModal: (modalName: string) => void;
  closeModal: () => void;
  isModalOpen: (modalName: string) => boolean;
  currentModal: ModalState;

  dataModal: Record<string, unknown>;
  setDataModal: (data: Record<string, unknown>) => void;

  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
};

export const PageContext = createContext<PageContextType | undefined>(
  undefined,
);
